import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { StoreProvider } from "./ui/store";
import { registerServiceWorker } from "./pwa/register";
import { initInstallCapture } from "./pwa/install";
import { initAnalytics } from "./ui/analytics";
import "./ui/styles.css";

// Host/path gate for the admin panel (the real gate is server-side on /api/admin/*).
// Both apps are lazy so the admin bundle never pulls the game (Phaser) chunk in.
const isAdmin =
  window.location.hostname.startsWith("admin.") || window.location.pathname.startsWith("/admin");

const App = lazy(() => import("./ui/App").then((m) => ({ default: m.App })));
const AdminApp = lazy(() => import("./ui/admin/AdminApp").then((m) => ({ default: m.AdminApp })));

registerServiceWorker();
initInstallCapture();
initAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StoreProvider>
      <Suspense fallback={<div className="splash">🌻</div>}>
        {isAdmin ? <AdminApp /> : <App />}
      </Suspense>
    </StoreProvider>
  </StrictMode>,
);
